import { Flex } from '@bynder/design-system';
import styled from 'styled-components';

export const StyledFlex = styled(Flex)`
    align-content: flex-start;
`;
